module.exports = __webpack_public_path__ + "img/authentic.24f8d25d.svg";